export default [
  {
    path: '/playground',
    name: 'Playground',
    meta: {
      title: 'Playground',
      authRequired: true,
    },
    component: () => import('../views/playground/Index.vue'),
  },
  {
    path: '/playground/service-proposal',
    name: 'PlaygroundServiceProposal',
    meta: {
      title: 'Service Proposal Playground',
      authRequired: true,
    },
    component: () => import('../views/playground/ServiceProposal.vue'),
  },
  {
    path: '/playground/service-proposal/:id',
    name: 'PlaygroundProposalDetail',
    meta: {
      title: 'Proposal Detail',
      authRequired: true,
    },
    component: () => import('../views/playground/ProposalDetail.vue'),
  },
  {
    path: '/playground/area-codes',
    name: 'PlaygroundAreaCodes',
    meta: {
      title: 'Area Codes Playground',
      authRequired: true,
    },
    component: () => import('../views/playground/AreaCodes.vue'),
  },
  {
    path: '/playground/area-codes/:id',
    name: 'PlaygroundAreaCodeDetail',
    meta: {
      title: 'Area Code Detail',
      authRequired: true,
    },
    component: () => import('../views/playground/AreaCodeDetail.vue'),
  },
  {
    path: '/playground/cities',
    name: 'PlaygroundCities',
    meta: {
      title: 'Cities Playground',
      authRequired: true,
    },
    component: () => import('../views/playground/Cities.vue'),
  },
  {
    path: '/playground/liquidation-integration',
    name: 'PlaygroundLiquidationIntegration',
    meta: {
      title: 'Liquidation Integration Tester',
      authRequired: true,
    },
    component: () => import('../views/playground/LiquidationIntegration.vue'),
  },
];
